import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiUsers, FiMessageCircle } from 'react-icons/fi';

const LargeGroupModal = ({ isOpen, onClose, passengerCount }) => {
  const handleWhatsAppContact = () => {
    const message = `Hello! I need transport for ${passengerCount} passengers and would like to discuss booking options with multiple vans.`;
    const whatsappUrl = `https://wa.me/447404560313?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-[#1a1012]/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          className="bg-white rounded-2xl shadow-2xl max-w-md w-full border border-black/10"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10">
            <div className="flex items-center">
              <FiUsers className="w-6 h-6 text-[#ba1609] mr-3" />
              <h2 className="text-xl font-bold text-[#1a1012]">Large Group Booking</h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-black/5 transition-colors text-[#1a1012]"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-[#fbeceb] rounded-full flex items-center justify-center mx-auto mb-4">
                <FiUsers className="w-8 h-8 text-[#ba1609]" />
              </div>
              <h3 className="text-lg font-semibold text-[#1a1012] mb-3">
                Special Arrangement Required
              </h3>
              <p className="text-[#5b4d4f] leading-relaxed">
                You've requested transport for <span className="font-semibold text-[#1a1012]">{passengerCount} passengers</span>.
                Our online booking system accommodates up to 21 passengers (3 vans), but we can definitely help arrange
                transportation for larger groups with additional vehicles.
              </p>
            </div>

            {/* Van capacity info */}
            <div className="bg-[#faf7f6] rounded-lg p-4 mb-6 border border-black/10">
              <h4 className="text-[#1a1012] font-medium mb-2">Our Fleet Capacity:</h4>
              <ul className="text-[#5b4d4f] text-sm space-y-1">
                <li>• Each van accommodates up to 7 passengers</li>
                <li>• Standard booking: Up to 3 vans (21 passengers)</li>
                <li>• Large groups: Additional vans available on request</li>
                <li>• We can coordinate multiple vehicles for your group</li>
              </ul>
            </div>

            {/* Contact section */}
            <div className="space-y-3">
              <button
                onClick={handleWhatsAppContact}
                className="w-full flex items-center justify-center px-6 py-3 bg-[#ba1609] hover:bg-[#8e1107] text-white font-medium rounded-lg transition-colors duration-300"
              >
                <FiMessageCircle className="w-5 h-5 mr-2" />
                Contact us on WhatsApp
              </button>

              <button
                onClick={onClose}
                className="w-full px-6 py-3 bg-white hover:bg-[#fbeceb] text-[#ba1609] font-medium rounded-lg border border-[#ba1609] transition-colors duration-300"
              >
                Try Different Group Size
              </button>
            </div>

            <div className="mt-4 text-center">
              <p className="text-[#5b4d4f] text-xs">
                We'll respond quickly to help arrange your group transportation
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LargeGroupModal;